/**
 * Платформа устройства (specs/001-pwa-shell R5; specs/006-pwa-notifications R2). Без React и
 * MobX: модуль собирают и мобильная версия, и service worker (`src/push/click.ts`).
 */

export type InstallPlatform = "android" | "ios" | "desktop" | "other";

/** Платформа по устройству. iPad с «настольным» user agent узнаётся по сенсорному экрану у «Macintosh» */
export function detectPlatform(userAgent: string, maxTouchPoints: number): InstallPlatform {
    if (/iPhone|iPad|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && maxTouchPoints > 1)) {
        return "ios";
    }

    if (/Android/.test(userAgent)) {
        return "android";
    }

    return /Windows|Macintosh|Linux|CrOS/.test(userAgent) && !/Mobi/.test(userAgent) ? "desktop" : "other";
}
